<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormHistoricalFigure
          :data="historicalFigure"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :isNew="!id"
          :language="language"
          @submit="onFormSubmit"
          @cancel="$router.push({ name: 'hostorical-figures' })"
          @delete-historicalFigure="deleteHistoricalFigure"
          @language-update="language = $event"
          @change:descriptionForMobile="changeDescForMobHandler($event)"/>
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmHistoricalFigureRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import historicalFiguresQuery from '@/services/gql/types/HistoricalFigures/queries/historicalFigure.gql'
import createHistoricalFigureMutation from '@/services/gql/types/HistoricalFigures/mutations/createHistoricalFigure.gql'
import updateHistoricalFigureMutations from '@/services/gql/types/HistoricalFigures/mutations/updateHistoricalFigure.gql'
import deleteHistoricalFigureMutation from '@/services/gql/types/HistoricalFigures/mutations/deleteHistoricalFigure.gql'
import FormHistoricalFigure from './form'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'
export default {
  name: 'PageHistoricalFigure',
  components: {
    ConfirmationDialog,
    FormHistoricalFigure
  },
  metaInfo () {
    return {
      title: this.id
        ? 'Редактировать историческую личность'
        : 'Создать историческую личность'
    }
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      historicalFigure: null
    }
  },
  computed: {
    isMutationLoading () {
      return this.$async.createHistoricalFigure.$pending || this.$async.updateHistoricalFigure.$pending
    },
    isFormLoading () {
      return (
        this.$apollo.queries.historicalFigure.loading
      )
    }
  },
  methods: {
    changeDescForMobHandler ({ fields, $event }) {
      fields.descriptionForMobile = $event
    },
    onFormSubmit (formData) {
      if (!this.id) {
        this.createHistoricalFigure(formData)
      } else {
        this.updateHistoricalFigure(formData)
      }
    },
    async createHistoricalFigure (data) {
      try {
        delete data.translations
        await this.$async.createHistoricalFigure.$perform({ data })
        this.$successMsg('Историческая личность добавлена')
        await this.$router.push({ name: 'page-historical-figures' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании исторической личности')
      }
    },
    async updateHistoricalFigure (data) {
      setTranslation(data, this.language)
      try {
        await this.$async.updateHistoricalFigure.$perform(
          {
            id: parseInt(this.id),
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )
        this.$successMsg('Историческая личность обновлена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении исторической личности')
      }
    },
    async deleteHistoricalFigure () {
      try {
        await this.$refs.confirmHistoricalFigureRemoving.open()
        await this.$async.deleteHistoricalFigure.$perform({ id: parseInt(this.id) })
        this.$successMsg('Историческая личность удалена')
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении исторической лчности ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-historical-figures' })
      }
    }
  },
  apollo: {
    historicalFigure: {
      fetchPolicy: 'network-only',
      query: historicalFiguresQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: parseInt(this.id)
          }
        }
      },
      context () {
        return {
          headers: {
            Language: getListWithNewMainLanguage(this.language, contentLocalesValues())
          }
        }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-historical-figures' })
        } else {
          this.historicalFigure = res?.data?.historicalFigure || null
        }
      }
    }
  },
  async: {
    createHistoricalFigure (variables) {
      return this.$apollo.mutate({
        mutation: createHistoricalFigureMutation,
        variables
      })
    },
    updateHistoricalFigure (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateHistoricalFigureMutations,
        variables,
        context: {
          headers
        }
      })
    },
    deleteHistoricalFigure (variables) {
      return this.$apollo.mutate({
        mutation: deleteHistoricalFigureMutation,
        variables
      })
    }
  }
}
</script>
